import type { Meta, StoryObj } from '@storybook/angular';
import { expect } from 'storybook/test';
import { CalendarIconComponent } from '../../../app/core/svg-icons/calendar-icon.component';

const meta: Meta<CalendarIconComponent> = {
  title: 'Atoms/Icons/CalendarIcon',
  component: CalendarIconComponent,
  parameters: {
    docs: {
      description: {
        component: 'A calendar icon component. Perfect for dates, events, booking systems, and temporal information.',
      },
    },
  },
};

export default meta;
type Story = StoryObj<CalendarIconComponent>;

export const Default: Story = {
  render: () => ({
    template: '<app-calendar-icon></app-calendar-icon>',
  }),
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-calendar-icon')).toBeTruthy();
  },
};

export const WineTastingEvents: Story = {
  render: () => ({
    template: `
      <div style="max-width: 600px;">
        <h3 style="margin-bottom: 1.5rem; color: #5C0A31;">Kommende vinsmagninger</h3>
        
        <div style="display: flex; flex-direction: column; gap: 1rem;">
          
          <div style="border: 1px solid #ddd; border-radius: 8px; padding: 1.5rem; transition: box-shadow 0.2s; cursor: pointer;"
               onmouseover="this.style.boxShadow='0 4px 12px rgba(0,0,0,0.1)'" onmouseout="this.style.boxShadow='none'">
            <div style="display: flex; gap: 1rem;">
              <div style="color: #5C0A31; margin-top: 0.25rem;">
                <app-calendar-icon></app-calendar-icon>
              </div>
              <div style="flex: 1;">
                <h4 style="margin: 0 0 0.5rem 0; color: #5C0A31;">Bordeaux Masterclass</h4>
                <p style="margin: 0 0 1rem 0; color: #666;">
                  Udforsk de finest Bordeaux vine med vores ekspertguide.
                </p>
                <div style="display: flex; gap: 2rem; font-size: 0.875rem;">
                  <div>
                    <strong>Dato:</strong><br>
                    <span style="color: #666;">15. marts 2024</span>
                  </div>
                  <div>
                    <strong>Tid:</strong><br>
                    <span style="color: #666;">19:00 - 21:30</span>
                  </div>
                  <div>
                    <strong>Pris:</strong><br>
                    <span style="color: #5C0A31; font-weight: bold;">599 kr</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div style="border: 1px solid #ddd; border-radius: 8px; padding: 1.5rem; transition: box-shadow 0.2s; cursor: pointer;"
               onmouseover="this.style.boxShadow='0 4px 12px rgba(0,0,0,0.1)'" onmouseout="this.style.boxShadow='none'">
            <div style="display: flex; gap: 1rem;">
              <div style="color: #5C0A31; margin-top: 0.25rem;">
                <app-calendar-icon></app-calendar-icon>
              </div>
              <div style="flex: 1;">
                <h4 style="margin: 0 0 0.5rem 0; color: #5C0A31;">Champagne & Østersaften</h4>
                <p style="margin: 0 0 1rem 0; color: #666;">
                  En elegant aften med champagne og friske østers.
                </p>
                <div style="display: flex; gap: 2rem; font-size: 0.875rem;">
                  <div>
                    <strong>Dato:</strong><br>
                    <span style="color: #666;">22. marts 2024</span>
                  </div>
                  <div>
                    <strong>Tid:</strong><br>
                    <span style="color: #666;">18:00 - 20:00</span>
                  </div>
                  <div>
                    <strong>Pris:</strong><br>
                    <span style="color: #5C0A31; font-weight: bold;">899 kr</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    `,
  }),
  parameters: {
    docs: {
      description: {
        story: 'Calendar icons used in wine tasting event listings.',
      },
    },
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-calendar-icon')).toBeTruthy();
  },
};

export const DeliveryDates: Story = {
  render: () => ({
    template: `
      <div style="border: 1px solid #ddd; border-radius: 8px; padding: 1.5rem; max-width: 400px;">
        <h4 style="margin: 0 0 1rem 0; color: #5C0A31;">Vælg leveringsdato</h4>
        
        <div style="display: flex; flex-direction: column; gap: 0.75rem;">
          
          <label style="display: flex; align-items: center; gap: 1rem; padding: 0.75rem; border: 1px solid #ddd; border-radius: 4px; cursor: pointer; transition: border-color 0.2s;"
                 onmouseover="this.style.borderColor='#5C0A31'" onmouseout="this.style.borderColor='#ddd'">
            <input type="radio" name="delivery" style="margin: 0;">
            <div style="color: #5C0A31;">
              <app-calendar-icon></app-calendar-icon>
            </div>
            <div style="flex: 1;">
              <strong>I morgen</strong><br>
              <span style="color: #666; font-size: 0.875rem;">23. februar 2024</span>
            </div>
            <span style="color: #5C0A31; font-weight: bold;">89 kr</span>
          </label>
          
          <label style="display: flex; align-items: center; gap: 1rem; padding: 0.75rem; border: 1px solid #ddd; border-radius: 4px; cursor: pointer; transition: border-color 0.2s;"
                 onmouseover="this.style.borderColor='#5C0A31'" onmouseout="this.style.borderColor='#ddd'">
            <input type="radio" name="delivery" style="margin: 0;" checked>
            <div style="color: #5C0A31;">
              <app-calendar-icon></app-calendar-icon>
            </div>
            <div style="flex: 1;">
              <strong>Mandag</strong><br>
              <span style="color: #666; font-size: 0.875rem;">26. februar 2024</span>
            </div>
            <span style="color: #5C0A31; font-weight: bold;">39 kr</span>
          </label>
          
          <label style="display: flex; align-items: center; gap: 1rem; padding: 0.75rem; border: 1px solid #ddd; border-radius: 4px; cursor: pointer; transition: border-color 0.2s;"
                 onmouseover="this.style.borderColor='#5C0A31'" onmouseout="this.style.borderColor='#ddd'">
            <input type="radio" name="delivery" style="margin: 0;">
            <div style="color: #5C0A31;">
              <app-calendar-icon></app-calendar-icon>
            </div>
            <div style="flex: 1;">
              <strong>Tirsdag</strong><br>
              <span style="color: #666; font-size: 0.875rem;">27. februar 2024</span>
            </div>
            <span style="color: #5C0A31; font-weight: bold;">39 kr</span>
          </label>
          
        </div>
        
        <button style="width: 100%; margin-top: 1rem; background-color: #5C0A31; color: white; border: none; padding: 0.75rem; border-radius: 4px; cursor: pointer; font-weight: bold;">
          Fortsæt til betaling
        </button>
      </div>
    `,
  }),
  parameters: {
    docs: {
      description: {
        story: 'Calendar icons used in delivery date selection.',
      },
    },
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-calendar-icon')).toBeTruthy();
  },
};

export const ProductAvailability: Story = {
  render: () => ({
    template: `
      <div style="border: 1px solid #ddd; border-radius: 8px; padding: 1rem; max-width: 300px;">
        <div style="background-color: #f8f9fa; height: 150px; margin-bottom: 1rem; border-radius: 4px; display: flex; align-items: center; justify-content: center; color: #666;">
          [Vin billede]
        </div>
        <h5>Dom Pérignon 2012</h5>
        <p style="color: #666; margin: 0.5rem 0;">Champagne, Frankrig</p>
        
        <div style="display: flex; align-items: center; gap: 0.5rem; margin: 1rem 0; padding: 0.5rem; background-color: #E8F5E8; border-radius: 4px; border-left: 4px solid #28A745;">
          <app-calendar-icon></app-calendar-icon>
          <span style="font-size: 0.875rem; color: #155724;">Leveres inden for 2-3 dage</span>
        </div>
        
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
          <strong style="color: #5C0A31; font-size: 1.25rem;">3.299 kr</strong>
        </div>
        
        <button style="width: 100%; background-color: #5C0A31; color: white; border: none; padding: 0.75rem; border-radius: 4px; cursor: pointer; font-weight: bold;">
          Køb nu
        </button>
      </div>
    `,
  }),
  parameters: {
    docs: {
      description: {
        story: 'Calendar icon used to show product availability timeline.',
      },
    },
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-calendar-icon')).toBeTruthy();
  },
};

export const OrderHistory: Story = {
  render: () => ({
    template: `
      <div style="max-width: 600px;">
        <h3 style="margin-bottom: 1.5rem; color: #5C0A31;">Ordrehistorik</h3>
        
        <div style="display: flex; flex-direction: column; gap: 1rem;">
          
          <div style="border: 1px solid #ddd; border-radius: 8px; padding: 1.5rem;">
            <div style="display: flex; justify-content: space-between; align-items: start; margin-bottom: 1rem;">
              <div>
                <h5 style="margin: 0 0 0.5rem 0;">Ordre #12345</h5>
                <div style="display: flex; align-items: center; gap: 0.5rem; color: #666; font-size: 0.875rem;">
                  <app-calendar-icon></app-calendar-icon>
                  <span>Bestilt 15. januar 2024</span>
                </div>
              </div>
              <span style="background-color: #28A745; color: white; padding: 0.25rem 0.75rem; border-radius: 12px; font-size: 0.75rem; font-weight: bold;">
                LEVERET
              </span>
            </div>
            <p style="margin: 0; color: #666;">3 varer • Total: 1.247 kr</p>
          </div>
          
          <div style="border: 1px solid #ddd; border-radius: 8px; padding: 1.5rem;">
            <div style="display: flex; justify-content: space-between; align-items: start; margin-bottom: 1rem;">
              <div>
                <h5 style="margin: 0 0 0.5rem 0;">Ordre #12344</h5>
                <div style="display: flex; align-items: center; gap: 0.5rem; color: #666; font-size: 0.875rem;">
                  <app-calendar-icon></app-calendar-icon>
                  <span>Bestilt 8. januar 2024</span>
                </div>
              </div>
              <span style="background-color: #F39C12; color: white; padding: 0.25rem 0.75rem; border-radius: 12px; font-size: 0.75rem; font-weight: bold;">
                AFSENDT
              </span>
            </div>
            <p style="margin: 0; color: #666;">2 varer • Total: 899 kr</p>
          </div>
          
        </div>
      </div>
    `,
  }),
  parameters: {
    docs: {
      description: {
        story: 'Calendar icons used in order history to show order dates.',
      },
    },
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-calendar-icon')).toBeTruthy();
  },
};

export const BookingForm: Story = {
  render: () => ({
    template: `
      <div style="border: 1px solid #ddd; border-radius: 8px; padding: 2rem; max-width: 400px;">
        <h3 style="margin: 0 0 1.5rem 0; color: #5C0A31;">Book vinsmagning</h3>
        
        <form style="display: flex; flex-direction: column; gap: 1rem;">
          
          <div>
            <label style="display: block; margin-bottom: 0.5rem; font-weight: bold; color: #333;">
              Vælg dato
            </label>
            <div style="position: relative;">
              <input type="date" style="width: 100%; padding: 0.75rem; padding-left: 3rem; border: 1px solid #ddd; border-radius: 4px; font-size: 1rem;">
              <div style="position: absolute; left: 0.75rem; top: 50%; transform: translateY(-50%); color: #5C0A31; pointer-events: none;">
                <app-calendar-icon></app-calendar-icon>
              </div>
            </div>
          </div>
          
          <div>
            <label style="display: block; margin-bottom: 0.5rem; font-weight: bold; color: #333;">
              Antal personer
            </label>
            <select style="width: 100%; padding: 0.75rem; border: 1px solid #ddd; border-radius: 4px; font-size: 1rem;">
              <option>1 person</option>
              <option>2 personer</option>
              <option>3 personer</option>
              <option>4 personer</option>
              <option>5+ personer</option>
            </select>
          </div>
          
          <div>
            <label style="display: block; margin-bottom: 0.5rem; font-weight: bold; color: #333;">
              Særlige ønsker
            </label>
            <textarea style="width: 100%; padding: 0.75rem; border: 1px solid #ddd; border-radius: 4px; font-size: 1rem; min-height: 80px; resize: vertical;" 
                      placeholder="Eventuelle allergier, præferencer eller særlige anmodninger..."></textarea>
          </div>
          
          <button style="background-color: #5C0A31; color: white; border: none; padding: 0.75rem; border-radius: 4px; cursor: pointer; font-weight: bold; font-size: 1rem;">
            Book nu
          </button>
          
        </form>
      </div>
    `,
  }),
  parameters: {
    docs: {
      description: {
        story: 'Calendar icon used in booking forms for date selection.',
      },
    },
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-calendar-icon')).toBeTruthy();
  },
};
